import { Box } from '@mui/material';
import React, { cloneElement, isValidElement, useState } from 'react';

import { Modal } from '@/shared/components/ui/modal-controller/modal-controller.styled';
import { TModalControllerProps } from '@/shared/components/ui/modal-controller/modal-controller.types';
import { usePermissions } from '@/shared/features/ability/hooks/use-permissions/use-permissions';

export const ModalController: React.FC<TModalControllerProps> = ({
  trigger,
  children,
  handleTriggerClick,
  permission,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const hasPermission = usePermissions(permission);

  const _handleClose = () => {
    setOpenModal(false);
  };

  const _handleClick = (event: React.BaseSyntheticEvent) => {
    event?.stopPropagation();
    setOpenModal(true);
    handleTriggerClick?.(event);
  };

  const renderTrigger = () => {
    if (!isValidElement(trigger)) {
      return null;
    }

    return cloneElement(trigger, {
      onClick: (event: React.BaseSyntheticEvent) => {
        event.preventDefault();
        _handleClick(event);
        trigger.props.onClick?.(event);
      },
    });
  };

  if (!hasPermission) {
    return null;
  }

  return (
    <>
      {renderTrigger()}
      <Modal open={openModal} onClose={_handleClose}>
        <Box>{children(_handleClose)}</Box>
      </Modal>
    </>
  );
};
